import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { UPDATE_DWNLD_STATE_DATA, } from "@frameworks/web/redux/interfaces/Reports/CoreReports/IDownloadNSendEmailReportReducer";
let initialState = {
    fromDate: new Date(),
    toDate: new Date(),
    reportType: "",
    searchParams: [],
    urlParts: "",
    email: true,
    download: true,
    pdfCheck: true,
    excelCheck: false,
    openDownloadPopup: false,
    showDownloadReportDPModal: false,
};
const DownloadNSendEmailReport = (state = initialState, action) => {
    var _a;
    switch (action.type) {
        case UPDATE_DWNLD_STATE_DATA:
            return Object.assign(Object.assign({}, state), ((_a = action.payload) !== null && _a !== void 0 ? _a : initialState));
        default:
            return state;
    }
};
export default combineReducers({
    reducersData: DownloadNSendEmailReport,
    commonData: commonOnePlatFormReducer,
});
